import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumericOnlyDirective } from '../../../directives/numeric-only.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { SharedModuleV3 } from '../../../shared/sharedv3.module';
import { MatIconModule } from '@angular/material/icon';
import { ErrorStateMatcher } from '@angular/material/core';
import { MyErrorStateMatcher } from '../../../types/v3/custom-error-state-matcher';

@Component({
  selector: 'app-form-field-numeric',
  standalone: true,
  imports: [
    CommonModule,
    SharedModuleV3,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    NumericOnlyDirective,
    MatIconModule
  ],
  templateUrl: './form-field-numeric.component.html',
  styleUrl: './form-field-numeric.component.scss',
  providers: [
    { provide: ErrorStateMatcher, useClass: MyErrorStateMatcher }
  ]
})
export class FormFieldNumericComponent {
  @Input() control!: FormControl;
  
  @Input() label: string='';
  @Input() placeholder: string='';
  @Input() hint: string='';
  @Input() formSubmitted: boolean = false;
}
